//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        // Initial Load
        getCareersData();

        // Filter changes
        $("#pickSubject").on("change", function(){
            getCareersData();
        });

        $("#pickInterest").on("change", function(){
            getCareersData();
        });

        $(".careers-form-check-input").on("change", function () {
            getCareersData();
        });

        // On show more click
        $(".careers-load-more").on("click", function() {
            showMore();
        });

    }

    function showMore()
    {   
        var showAmount = 10;
        var $careerResults = $("#careerResults");

        $careerResults.find("div.career-picker-row:hidden:lt(" + showAmount + ")").show();

        // if there are no more results, hide the load more button.
        if($careerResults.find("div.career-picker-row:hidden").length <= 0){
            $(".careers-load-more").hide();
        }

    }

    function getCareersData()
    {
        var degreeTypes = $(".careers-form-check-input:checked").map(function(){
            return $(this).val();
        }).get();

        var $subject = $("#pickSubject");
        var $interest = $("#pickInterest");

        var subject = $subject.val();
        var interest = $interest.val();

        var subjectName = $subject.find("option:selected").text();
        var interestName = $interest.find("option:selected").text();

        if(subject == "By Subject"){
            subject = "";
        }

        if(interest == "By Interest"){
            interest = "";
        }

        $.ajax({
            url: window.curry.careerFeed,
            type: "POST",
            data: {
                SubjectName: subjectName,
                InterestName: interestName,
                Subject: subject,
                Interest: interest,
                DegreeTypes: degreeTypes
            },
            success: function (response) {
                var $careerResults = $("#careerResults");
                $careerResults.html(response);

                var showAmount = 10;

                // Only show a certain amount.
                var $tiles = $careerResults.find("div.career-picker-row");
                
                $tiles.hide();
                
                $careerResults.find("div.career-picker-row:lt(" + showAmount + ")").show();

                // Determine if the load more button should show up.
                if($careerResults.find("div.career-picker-row:hidden").length <= 0){
                    $(".careers-load-more").hide();
                }
                else {
                    $(".careers-load-more").show();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/careers.js